import script from "./GameHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./GameHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./GameHistoryView.vue?vue&type=style&index=0&id=79dec8c6&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79dec8c6"]])

export default __exports__